import { JobsiteAccessActivityContainer } from 'containers/jobsiteAccessActivity/JobsiteAccessActivityContainer';

const name = 'JobsiteAccessActivityContainer';

export { name, JobsiteAccessActivityContainer };
